import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';

const CURRENT_AUTH_INFO = 'currentAuthInfo';

export default function initStore(initialState) {
    function loadStoredState(state){
        try {
            let storedAuthInfo = localStorage.getItem(CURRENT_AUTH_INFO);

            if (storedAuthInfo !== null) {
                storedAuthInfo = JSON.parse(storedAuthInfo);
                let now = new Date();

                let expiration = new Date(storedAuthInfo.expires);
                if (expiration > now) {
                    state.user = storedAuthInfo;
                }
            }
        } catch (e) {
            console.warn(e);
        }

        return state;
    }

    const store = createStore(
        rootReducer,
        loadStoredState(initialState),
        applyMiddleware(thunk)
    );

    function getAuthInfo(state){
        return state.user;
    }

    let currentAuthInfo = undefined;
    store.subscribe(() => {
        try {
            let previousAuthInfo = currentAuthInfo;
            currentAuthInfo = getAuthInfo(store.getState());

            if (previousAuthInfo != currentAuthInfo) {
                let json = JSON.stringify(currentAuthInfo);
                localStorage.setItem(CURRENT_AUTH_INFO, json);
            }
        } catch (e) {
            console.warn(e);
        }
    });

    return store;
}